<template>
  <div>
    <v-card>
      <v-card-text>
        <Plan
            :endpoint_load="'/admin/plan/plan.get?id=' + this.plan_id"
            endpoint_edit="/admin/plan/plan.edit"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Plan from "@/components/Plan";

export default {
  components: {
    Plan
  },
  data() {
    return {
      plan_id: this.$router.currentRoute.params.plan_id
    }
  }
}
</script>

<style>

</style>